import type { ReactNode } from 'react';

// Wraps a human field label with a native-title tooltip revealing the
// underlying Exigo slot (e.g. "field3", "g1.field2" for CustomerExtended
// group 1 field2, or "other14" for an order custom field), so operators can
// correlate a label back to its source on hover. A dotted underline signals
// the tooltip. Anything not matching a slot pattern renders unchanged (no
// tooltip), so it's safe to wrap every label.
const FIELD_SLOT_RE = /^(field\d+|g\d+\.field\d+|other\d+)$/;

export function FieldLabel({ name, children }: { name?: string | null; children: ReactNode }) {
  if (!name || !FIELD_SLOT_RE.test(name)) return <>{children}</>;
  return (
    <span title={name} className="border-b border-dotted border-gray-400/60">
      {children}
    </span>
  );
}
